document.addEventListener('DOMContentLoaded', function() {
    $(document).ready(function() {
        $('.form-certificado').submit(function(e) {
            e.preventDefault();
            var form = $(this);
            if (!form.hasClass('loading')) {
                form.addClass('loading');
                $.ajax({
                    url: form.attr('action'),
                    type: 'POST',
                    dataType: 'json',
                    data: form.serialize(),
                    error: function() {
                        console.error('Error searching certificado');
                        Swal.fire({
                            title: jsi18n.ajax_error_title,
                            text: jsi18n.ajax_error_message,
                            imageUrl: site_url + 'site/img/iconError.png',
                            imageWidth: 76,
                            imageHeight: 76
                        });
                        form.removeClass('loading');
                    },
                    success: function(json) {
                        if (json.status) {
                            Swal.fire({
                                title: json.title,
                                text: json.message,
                                imageUrl: site_url + 'site/img/iconSuccess.png',
                                imageWidth: 76,
                                imageHeight: 76
                            });
                            setTimeout(function() {
                                window.open(json.url, '_blank');
                            }, json.timeout);
                            form[0].reset();
                        } else {
                            Swal.fire({
                                title: json.title,
                                text: json.message,
                                imageUrl: site_url + 'site/img/iconError.png',
                                imageWidth: 76,
                                imageHeight: 76
                            });
                        }
                        form.removeClass('loading');
                    }
                });
            }
        });
    });
});